<template>
<div class="desktop-footer">
  <div class="inner-footer">
    <div class="footer-up">
      <div class="columns">
        <div class="column is-9">
          <div class="columns is-multiline is-gapless">
            <div class="column is-4">
              <template>
              <div v-show="infoServiceReady">
                <ItemList v-on="$listeners" v-if="footerInfo" v-bind:listContent="footerEurekoInfo(0)"></ItemList>
              </div>
              </template>
            </div>
            <div class="column is-4">
              <template>
              <div v-show="infoServiceReady">
                <ItemList v-on="$listeners" v-if="footerInfo" v-bind:listContent="footerEurekoInfo(1)"></ItemList>
              </div>
              </template>
            </div>
            <div class="column is-4">
              <template>
              <div v-show="infoServiceReady">
                <ItemList v-on="$listeners" v-if="footerInfo" v-bind:listContent="footerEurekoInfo(2)"></ItemList>
              </div>
              </template>
            </div>
            <div class="column is-8">
              <div class="columns is-multiline is-gapless">
                <div class="column is-half">
                  <template>
                  <div v-show="infoServiceReady">
                    <ItemList v-on="$listeners" v-if="footerInfo" v-bind:listContent="footerEurekoInfo(3)"></ItemList>
                  </div>
                  </template>
                </div>
                <div class="column is-half">
                  <template>
                  <div v-show="infoServiceReady">
                    <ItemList v-on="$listeners" v-if="footerInfo" v-bind:listContent="footerEurekoInfo(4)"></ItemList>
                  </div>
                  </template>
                </div>
                <div class="column is-full">
                  <div class="columns is-multiline">
                    <div class="text column is-5 social is-middle">{{ $t("titles.social") }}</div>
                    <div class="social" style="margin-top: 0px;width: 314px;max-width: 304px;justify-content: center;padding-left: 20px;">
                      <div style="display: flex;width: 254px;">
                        <div class="column is-3">
                          <a rel="noopener nofollow" href="https://www.facebook.com/eurekosigorta" alt="Eureko Sigorta Facebook" name="facebook" target="_blank">
                            <div class="facebook-blue-icon"></div>
                          </a>
                        </div>
                        <div class="column is-3">
                          <a rel="noopener nofollow" href="https://www.twitter.com/eurekosigorta" alt="Eureko Sigorta Twitter" name="twitter" target="_blank">
                            <div class="twitter-blue-icon"></div>
                          </a>
                        </div>
                        <div class="column is-3">
                          <a rel="noopener nofollow" href="https://www.instagram.com/eurekosigorta/" alt="Eureko Sigorta Instagram" name="instagram" target="_blank">
                            <div class="instagram-blue-icon"></div>
                          </a>
                        </div>
                        <div class="column is-3">
                          <a rel="noopener nofollow" href="https://linkedin.com/company/eurekosigorta" alt="Eureko Sigorta Linkedin" name="linkedin" target="_blank">
                            <div class="linkedin-blue-icon"></div>
                          </a>
                        </div>
                        <div class="column is-3">
                          <a rel="noopener nofollow" href="https://www.youtube.com/@eurekodigital" alt="Eureko Sigorta Youtube" name="youtube" target="_blank">
                            <div class="youtube-blue-icon"></div>
                          </a>
                        </div>
                        <div class="column is-3">
                          <a rel="noopener nofollow" href="https://www.tiktok.com/@eureko.sigorta" alt="Eureko Sigorta Tiktok" name="tiktok" target="_blank">
                            <div class="tiktok-blue-icon"></div>
                          </a>
                        </div>
                       </div>
                      </div>
                    <div class="column is-12">
                      <div class="columns">
                        <div class="text column is-6 social">{{ $t("titles.mobileAppsTitle") }}</div>
                        <div class="column is-6">
                          <a :href="'https://apps.apple.com/us/app/eureko-sigorta/id1312238086?l=' + $i18n.locale" name="app-store" class="app-store-icon" alt="Eureko Sigorta App Store" target="_blank" rel="noopener nofollow"></a>
                          <a :href="'https://play.google.com/store/apps/details?id=com.eurekosigorta.mobile&hl=' + $i18n.locale" name="google-play" class="google-play-icon" alt="Eureko Sigorta Google Play" target="_blank" rel="noopener nofollow"></a>
                          <a href="https://appgallery.huawei.com/app/C104054935" name="huawei-appgallery" class="huawei-appgallery-icon" alt="Eureko Sigorta Huawei App Gallery" target="_blank" rel="noopener nofollow" ></a>
                        </div>
                        <!-- <div class="column is-6">
                          <div class="columns is-multiline">
                            <div class="column is-4">
                              <a :href="'https://apps.apple.com/us/app/eureko-sigorta/id1312238086?l=' + $i18n.locale" name="app-store" class="app-store-icon" alt="Eureko Sigorta App Store" target="_blank" rel="noopener nofollow"></a>
                            </div>
                            <div class="column is-4">
                              <a :href="'https://play.google.com/store/apps/details?id=com.eurekosigorta.mobile&hl=' + $i18n.locale" name="google-play" class="google-play-icon" alt="Eureko Sigorta Google Play" target="_blank" rel="noopener nofollow"></a>
                            </div>
                            <div class="column is-4">
                              <a href="https://appgallery.huawei.com/app/C104054935" name="huawei-appgallery" class="huawei-appgallery-icon" alt="Eureko Sigorta Huawei App Gallery" target="_blank" rel="noopener nofollow" ></a>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div>
            <div>
              <div class="contact-details">
                <div class="column is-mobile reach-us">
                  <span>{{ $t('texts.reachUs') }}</span>
                </div>
                <div class="columns is-gapless">
                  <div class="column is-2 is-middle"><div class="call-icon"></div></div>
                  <div class="column is-mobile detail-item">
                    <a v-if="$isDesktop" v-on:click="itemDetailShow = true">{{ $t('texts.reachToCallCenter') }}</a>
                    <a v-if="!$isDesktop" href="tel:08502226660">{{ $t('texts.reachToCallCenter') }}</a>
                  </div>
                </div>
                <modal :title="$t('texts.reachToCallCenterText')" :width="400" :height="400" :is-show="itemDetailShow" :show-header=false :show-footer=false transition="fadeDown" @close="itemDetailShow=false">
                  <div class="lineer-background">
                    <div class="is-center">
                      <div class="column reacCallCenter" v-html="$t('texts.reachToCallCenterText')" ></div>
                      <div class="column qrcode"><qrcode value="0850 222 66 60" :options="{ size: 99 }"></qrcode></div>
                      <div class="info-message">
                        <div class="qrcode-phone-icon"></div>
                        <div class="quickCallQrCode" v-html="$t('texts.quickCallQrCode')"></div>
                      </div>
                    </div>
                  </div>
                </modal>
                <div class="columns is-gapless">
                  <div class="column is-2"><div class="mail-icon"></div></div>
                  <div class="column is-mobile detail-item">
                    <router-link :to="{ name: 'ContactForm'}">{{ $t('texts.contactUs') }}</router-link>
                  </div>
                </div>
                <div class="columns is-gapless">
                  <div class="column is-2"><div class='pin'></div></div>
                  <div class="column is-9">
                    <div class="address">
                      <span>{{ $t('texts.eurekoAddress') }}</span>
                    </div>
                  </div>
                </div>
                <div class="columns brands is-mobile is-middle">
                  <div class="column">
                    <i class="footer-bbs">
                    <a rel="noopener" href="/api/Content/assets/pdf/eb289489dbf14cfb9d8fd8869a8ef1ee" target="_blank"></a>
                    </i>
                    <i class="footer-hsap">
                    <router-link :to="{ name: 'Query'}"></router-link>
                    </i>
                    <i class="footer-dask">
                    <a rel="noopener nofollow" href="https://www.dask.gov.tr/" target="_blank"></a>
                    </i>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="$i18n && $i18n.locale === 'tr'" class="google-maps">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.2086443242774!2d29.041961315662284!3d41.02069102660921!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab876c82aabcd%3A0x80c167841354d830!2sEureko%20Sigorta!5e0!3m2!1str!2str!4v1574153180740!5m2!1str!2str" width="320" height="270" frameborder="0" style="border:0;margin-top:30px" allowfullscreen=""></iframe>
            </div>
            <div v-else class="google-maps">
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6020.4398687772955!2d29.04607!3d41.020444!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x80c167841354d830!2sEureko%20Sigorta!5e0!3m2!1sen!2str!4v1574153215051!5m2!1sen!2str" width="320" height="270" frameborder="0" style="border:0;margin-top:30px" allowfullscreen=""></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bottom is-middle">Copyright © {{ date | moment('YYYY')}} {{ $t("texts.allRightsReserved") }}</div>
  <template v-if="cookieLawComponentActive">
  <cookie-law theme="base--rounded" :buttonText="$t('buttons.okay')">
  <div slot="message" v-html="$t('texts.cookiePolicy')">
  </div>
  </cookie-law>
  </template>
</div>
</template>
<script>

import service from '@/service'
import ItemList from '@/shared/widget/itemList'
import VueQrcode from '@xkeshi/vue-qrcode'
export default {
  name: 'Footer',
  components: {
    ItemList,
    'CookieLaw': () => import('vue-cookie-law'),
    'qrcode': VueQrcode
  },
  mounted () {
    var self = this
    self.getFooterInfo()
    setTimeout(function () {
      self.cookieLawComponentActive = true
    }, 5000)
  },
  methods: {
    getFooterInfo: function () {
      var self = this

      service.content.footers(self).then(function (response) {
        if (response === null) return
        self.footerInfo = response.data.footermenus
        self.infoServiceReady = true
      })
    },
    footerEurekoInfo: function (index) {
      // `this` points to the vm instance
      var tempArray = []
      if (this.footerInfo) {
        tempArray.push(this.footerInfo[index])
      }
      return tempArray
    }
  },
  computed: {
    mobileAppUrl: function () {
      return !this.$isDesktop ? 'https://bit.ly/2YkaLBk' : ''
    }
  },
  data () {
    return {
      cookieLawComponentActive: false,
      date: new Date(),
      eurekoInfo: null,
      generalInfo: null,
      footerInfo: null,
      infoServiceReady: false,
      map: {
        center: { lat: 41.020857, lng: 29.044150 },
        markers: [{position: { lat: 41.020857, lng: 29.044150 }}],
        currentPlace: { lat: 41.020857, lng: 29.044150 }
      },
      itemDetailShow: false,
      lang: this.$i18n.locale
    }
  }
}
</script>
<style scoped>
.desktop-footer {
  width: 100%;
  height: 710px;
  background-color: var(--light-bg1);
  border-top: 1px solid var(--border-color9);
}
.qrcode-phone-icon{
  display:inline-block;
}
.quickCallQrCode{
  width: 150px;
  font-size: 12px;
  margin: -40px 0px 0px 40px;
  display: block;
}
.desktop-footer .footer-bottom {
  height: 61px;
  text-align: center;
  justify-content: center;
  background-color: var(--text-color9);
  bottom: 0;
  color: var(--text-color4);
  font-size: 0.750em;
}
.lineer-background{
  margin-left: -20px;
  margin-right: -24px;
  margin-bottom: -28px;
  background: linear-gradient(180deg, white 60%, rgb(247, 247, 247) 30%);
}
.is-center {
  padding-bottom: 20px;
  margin-left: 20px;
  background-image: url(/static/img/callCenterAvatar.png);
  background-repeat: no-repeat;
  background-position: right bottom;
}
.reacCallCenter {
  font-size: 20px;
  line-height: 26.97px;
  width: 236px;
}
.qrcode {
  width: 110px;
  height: 110px;
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
  border-radius: 10px;
  display: flex;
  padding: 5px;
}
.info-message {
  height: 50px;
  padding-top: 20px;
}
/* .desktop-footer .map {
  padding-top: 24px;
} */

/*
.store-icon {
  text-align: center;
  max-width: 314px;
  min-width: 314px;
  width: 314px;
}
*/

/* @media only screen and (max-width: 1220px) {
  .store-icon {
    text-align: left;
    max-width: 0px;
    min-width: 0px;
    width: 0px;
  }
} */
.inner-footer {
  /* height: 650px; */
  padding: 55px 135px;
}
/* contact */
.contact {
  background-color: #ffffff;
}
.reach-us {
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.3px;
  color: var(--text-color1);
  padding: 5px 0 26px 0 !important;
}
.contact-details .detail-item {
  font-size: 1em;
  line-height: 0.94;
  letter-spacing: -0.4px;
  color: var(--eureko-blue);
}
.contact-details .column {
  padding: 0;
}
.contact-details .column.is-2 {
  width: 11%;
}
.contact-details .columns.is-multiline {
  margin-bottom: 0;
}
.contact .map {
  height: 10.625em;
}
.contact-details .columns:last-child .column:first-child {
  padding-top: 0.5em;
}
/*Social*/
.social {
  border-top: 1px solid var(--border-color9);
  padding-top: 19px;
  color: var(--text-color1);
  letter-spacing: -0.3px;
  font-size: 0.875em;
  display: flex !important;
  max-width: 152px;
}
.brands {
  padding: 0 10px;
}
.brands a {
  height: 100%;
  width: 42px;
  display: block;
}
.Cookie {
  font-size: 14px;
  color: var(--text-color1);
  max-width: 50%;
  margin: auto;
  margin-bottom: 16px;
	
	-webkit-border-radius: 0.25em;
  -moz-border-radius: 0.25em;
  border-radius: 0.25em;
  background-color: var(--light-bg1);
  /* -webkit-box-shadow: 0 4px 8px 0 rgba(0, 20, 39, 0.12);
  -moz-box-shadow: 0 4px 8px 0 rgba(0, 20, 39, 0.12);
  box-shadow: 0 4px 8px 0 rgba(0, 20, 39, 0.12); */
  box-shadow: 0 6px 22px 0 rgba(0,0,0,.1);
}
.mobile-app .mobile-app-desc {
  font-size: 0.875em;
  color: var(--text-color1);
  letter-spacing: -0.3px;
}
.download-app .social {
  border-top: 0;
  padding-top: 22px;
}
div >>> section {
  overflow: hidden;
}
</style>
<style>
.desktop-footer a {
  opacity: 1;
  font-size: 0.875em;
  font-weight: 300;
}
@media only screen and (max-width: 1325px) {
  .desktop-footer a {
    font-size: 0.688em
  }
  .desktop-footer span {
    font-size: 0.75em
  }
}

.desktop-footer span {
  font-size: 0.875em;
  font-weight: 600;
}
.desktop-footer .address span {
  color: var(--text-color1);
  font-weight: normal;
}
@media only screen and (max-width: 1325px) {
  .desktop-footer .address span {
    font-size: 0.75em
  }
}
.desktop-footer .item-list .tab-content {
  margin-left: 0;
  margin-top: 21px;
  size: 14px;
  line-height: 30px;
  letter-spacing: -0.4px;
  margin-bottom: 30px;
}
.desktop-footer .item-list .tab-content ul {
    margin-left: 0 !important;
}
.desktop-footer .columns.is-gapless:not(:last-child) {
  margin-bottom: 16px !important;
}
.Cookie .Cookie__button {
  background: var(--btn-primary) !important;
  color: var(--text-color4) !important;
  cursor: pointer !important;
  padding: 10px 20px !important;
  font-weight: 700 !important;
  border-radius: 18px !important;
  min-width: 84px !important;
  display: block !important;
}
.Cookie a {
  font-size: 14px !important;
  color: var(--eureko-blue) !important;
}
</style>



// WEBPACK FOOTER //
// src/desktop/widget/footer.vue